import Vue from 'vue'

const eventBus = new Vue({
  data () {
    return {
      nativeShowLoading: false
    }
  },
  methods: {

  },
  watch: {
    nativeShowLoading (newVal) {
      if (!newVal) {
        this.$emit('showLoading', false)
      }
    }
  }
})

export default eventBus // Global event bus
